import React from 'react';
import Box from '../../../elements/Box';
import Text from '../../../elements/Text';
import { TextProps } from '../../../elements/Text/Text';
import Title from './Title';
import { StyledProps } from '@front10';

interface Props {
  showTitle?: boolean;
  showLocationType?: boolean;
  data: string[];
  titleStyles?: React.ComponentPropsWithoutRef<typeof Title>;
  locationTypeStyles?: TextProps;
}

function LocationType({
  showTitle = true,
  showLocationType = true,
  data = [],
  titleStyles,
  locationTypeStyles,
  ...props
}: StyledProps<Props>) {
  return (
    <Box
      className="station-item-ticket-type"
      display="flex"
      flexDirection="column"
      borderTop={true}
      paddingTop="2"
      paddingBottom="2"
      {...props}
    >
      {showTitle && (
        <Title
          marginBottom="1"
          leftIcon="info-circle"
          labelKey="cmp-bus-directory-map-location-type"
          {...titleStyles}
        />
      )}
      {showLocationType &&
        data.map((item) => (
          <Text key={item} {...locationTypeStyles}>
            {item}
          </Text>
        ))}
    </Box>
  );
}

LocationType.componentName = 'LocationType';

export default LocationType;
